import GuidanceRegistry from '../guidance-registry.js';

GuidanceRegistry.register({
    type: "action-item-ewf-guided-setup-grace-period",
    prompt: (guidanceItem) => `Would you like to elect the grace period option for your DCA?`, 
    briefDescription: 'Grace Period',
    openAction: {
        text: "Where to view plan options?",
        url: (guidanceItem) => `/employer/${guidanceItem.employerId}/plans?planId=${guidanceItem.parameters.planId}`,
        row: "Plan Options",
    },
    actions: [
        { 
            text: "Yes, I elect the grace period option",
            visible: () => true,
            recommended: true,
            click: async (component, guidanceItem) => {
                await romeApi.post(`employer/${guidanceItem.employerId}/plan/${guidanceItem.parameters.planId}/update-grace-period`);
                await component.$store.dispatch("plans/load", {employerId: guidanceItem.employerId, refreshSameEmployer: true});
                await romeApi.post(`actionitem/v-2/${guidanceItem.actionItemId}/complete`);
            }
        },
        { 
            text: "No, continue",
            visible: () => true,
            click: async (component, guidanceItem) =>  {
                await romeApi.post(`actionitem/v-2/${guidanceItem.actionItemId}/complete`);
            },
        }
    ]
});


// WEBPACK FOOTER //
// ./src/guidance/items/guidance-grace-period.js